import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import b1 from "../../assets/images/homeBanner1.png";
import b2 from "../../assets/images/homeBanner2.png";
import b3 from "../../assets/images/homeBanner3.png";
import b4 from "../../assets/images/b4.png";

import todaySpecial from "../../assets/images/Today’s Special.png";
import freshPicks from "../../assets/images/Fresh Picks.png";
import snackBreak from "../../assets/images/Snack Break.png";
import menuBuilt from "../../assets/images/Hungry For More_.png";

const HomeBanner = () => {
  const history = useNavigate();

  const banners = [
    {
      title: "Small Smoked BBQ Pulled Pork",
      subtitle: todaySpecial,
      desc: "Slow-smoked, tender pulled pork packed with rich BBQ flavor and served fresh off the grill. A little portion with big-time taste.",
      btn: "ORDER TODAY'S SPECIAL",
      url: "/special",
      img: b1,
      width: "1440",
      titleWidth: ""
    },
    {
      title: "A Menu Built for Every Craving",
      subtitle: menuBuilt,
      desc: "Our kitchen doesn’t stop at one signature dish. Discover a curated selection of authentic flavors and timeless favorites designed for every palate.",
      btn: "VIEW MENU",
      url: "/menu",
      img: b4,
      width: "1440",
      titleWidth: "398"
    },
    {
      title: "All Your Favorites in One Place",
      subtitle: freshPicks,
      desc: "From pantry staples to fresh produce, snacks, and more — everything you need, all in one stop.",
      btn: "VIEW MENU",
      url: "/store/vendors",
      img: b2,
      width: "1440",
      titleWidth: ""
    },
    {
      title: "Snack Break Favorites",
      subtitle: snackBreak,
      desc: "Quick bites, bold flavors, and satisfying snacks to fuel your day anytime.",
      btn: "VIEW MENU",
      url: "/store/vendors",
      img: b3,
      width: "1440",
      titleWidth: ""
    },
  ];

  const [centerIndex, setCenterIndex] = useState(0);
  const [bp1815, setBp1815] = useState(false);
  const [bp1715, setBp1715] = useState(false);
  const [bp1615, setBp1615] = useState(false);
  const [bp1555, setBp1555] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      setBp1815(w <= 1815);
      setBp1715(w <= 1715);
      setBp1615(w <= 1615);
      setBp1555(w <= 1555);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCenterIndex((prev) => (prev + 1) % banners.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [banners.length]);

  const getPosition = (index) => {
    const total = banners.length;
    const diff = (index - centerIndex + total) % total;

    if (diff === 0) return "center";
    if (diff === 1) return "right";
    if (diff === total - 1) return "left";
    return "hidden";
  };

  const styles = {
    center: {
      left: "50%",
      scale: 1,
      zIndex: 30,
      opacity: 1,
    },
    left: {
      left: bp1555 ? "-73%" : bp1615 ? "-43%" : bp1715 ? "-40%" : bp1815 ? "-35%" : "-30%",
      scale: bp1715 ? 0.75 : 0.85,
      opacity: 0.6,
      zIndex: 20,
    },
    right: {
      left: bp1555 ? "173%" : bp1615 ? "143%" : bp1715 ? "140%" : bp1815 ? "135%" : "130%",
      scale: bp1715 ? 0.75 : 0.85,
      opacity: 0.6,
      zIndex: 20,
    },
    hidden: {
      opacity: 0,
      scale: 0.7,
      zIndex: 0,
    },
  };

  return (
    <section id="home-banner">
      <div className="custom-carousel-container">
        <div className="custom-carousel">
          {banners.map((banner, index) => {
            const pos = getPosition(index);
            const s = styles[pos];

            return (
              <div
                key={index}
                className="banner-slide"
                style={{
                  left: s.left,
                  opacity: s.opacity,
                  zIndex: s.zIndex,
                  transform: `translateX(-50%) scale(${s.scale})`,
                  transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
                onClick={() => setCenterIndex(index)}
              >
                <div className="banner-image-container">
                  <img src={banner.img} alt={banner.title} width={banner.width} className="banner-full-image" />
                </div>

                <div className="banner-text-overlay">
                  <span className="subtitle">
                    <img src={banner.subtitle} alt="subtitle" width={banner.titleWidth ? banner.titleWidth : ""} className="subtitle-img" />
                  </span>

                  <h1 className="title">{banner.title}</h1>

                  <p className={`description ${banner.img === b2 ? "des-gray" : "des-white"}`}>{banner.desc}</p>

                  <button
                    className={`cta-button ${
                      banner.img === b1 || banner.img === b4 ? "cta-btn-red" : banner.img === b2 ? "cta-btn-blue" : "cta-btn-transparent"
                    }`}
                    onClick={() => history(banner.url)}
                  >
                    {banner.btn}
                  </button>
                </div>

                <div className="image-dark-overlay"></div>
              </div>
            );
          })}
        </div>

        {/* ===================== DOTS ===================== */}
        <div className="carousel-dots">
          {banners.map((_, i) => (
            <button key={i} className={`dot ${i === centerIndex ? "active" : ""}`} onClick={() => setCenterIndex(i)} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
